import React, { Component } from 'react'
import ViewOrUpdateUI from './ViewOrUpdateUI.js'

class ViewOrUpdateSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      viewState: true
    }
  }

  render() {
    return (
      <ViewOrUpdateUI
        context={this.props.context}
        messageList={this.props.messageList}
        labelMessageKey={this.props.labelMessageKey}
        viewState={this.state.viewState}
        leftViewUI={this.props.leftViewUI}
        rightViewUI={this.props.rightViewUI}
        updateUI={this.props.updateUI}
        setViewState={this.setViewState}
        setUpdateState={this.setUpdateState}
      />
    )
  }

  setViewState = () => {
    this.setState({viewState: true})
  }

  setUpdateState = () => {
    this.setState({viewState: false})
  }
}

export default ViewOrUpdateSF
